import React from 'react';

import { PartnerType } from 'types/Partner';
import { useFetchPartnerEditHistory } from 'hooks/queries/useFetchPartnerEditHistory';
import EditHistoryModalContent from 'views/EditHistory/EditHistoryModalContent';

const EditPartnerHistoryModal = ({ partnerType, techId }: { partnerType: PartnerType; techId: string }) => {
  const { data, isFetching } = useFetchPartnerEditHistory(techId, partnerType);

  return <EditHistoryModalContent data={data} isFetching={isFetching} />;
};

export default EditPartnerHistoryModal;
